var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwapSrp = function SvgSwapSrp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "swapSRP_svg__a",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED6521",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#swapSRP_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F17",
    d: "M21.968 17.47a.87.87 0 0 1-.3-.684q0-.416.3-.716l3.067-3.067H16a.97.97 0 0 1-1-1q0-.433.284-.717a.97.97 0 0 1 .716-.283h9.034l-3.067-3.067q-.3-.3-.3-.717 0-.416.3-.716t.7-.3.7.3l4.667 4.667a1.1 1.1 0 0 1 .25.383 1.26 1.26 0 0 1 0 .9q-.084.216-.25.383l-4.667 4.667a.9.9 0 0 1-.7.283 1.02 1.02 0 0 1-.7-.316M8.635 25.503l-4.667-4.666a1.1 1.1 0 0 1-.25-.384 1.23 1.23 0 0 1 0-.9q.084-.217.25-.383l4.667-4.667q.3-.3.7-.3t.7.3.3.716a.98.98 0 0 1-.3.718l-3.067 3.066h9.033q.434 0 .718.283.282.284.282.717a.97.97 0 0 1-.282.716.97.97 0 0 1-.718.284H6.968l3.067 3.067q.3.3.3.716 0 .417-.3.684-.3.3-.7.316a.9.9 0 0 1-.7-.283"
  }))));
};
export default SvgSwapSrp;